import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import * as reactSpark from "react-spark";
import InputField from "../../input-field/InputField";

const { Stack } = reactSpark;

export const birthMonthValidation = {
  validateOn: ["blur"],
  required: true,
  message: {
    default: "Please enter a month"
  }
};

export const birthDayValidation = {
  validateOn: ["blur"],
  required: true,
  message: {
    default: "Please enter a day"
  }
};

export const birthYearValidation = {
  validateOn: ["blur"],
  required: true,
  message: {
    default: "Please enter a year"
  }
};

class BirthdateWithInputFields extends Component {
  getMonth() {
    const { birthdate } = this.props;

    return birthdate
      ? (new Date(birthdate).getUTCMonth() + 1).toString()
      : undefined;
  }

  getDay() {
    const { birthdate } = this.props;

    return birthdate
      ? new Date(birthdate).getUTCDate().toString()
      : undefined;
  }

  getYear() {
    const { birthdate } = this.props;

    return birthdate
      ? new Date(birthdate).getUTCFullYear().toString()
      : undefined;
  }

  render() {
    const {
      disabled
    } = this.props;

    return (
      <Fragment>
        <label className="sprk-b-Label sprk-u-mbn">Date of Birth (MM/DD/YYYY)</label>
        <Stack
          className="Onboarding-MonthDayYearRow space-stack-s"
          splitAt="tiny"
        >
          <Stack.Item className="Onboarding-MonthInputContainer">
            <InputField
              id="birthMonth"
              name="birthMonth"
              disabled={disabled}
              validation={birthMonthValidation}
              value={this.getMonth()}
            />
          </Stack.Item>
          <Stack.Item className="Onboarding-DayInputContainer">
            <InputField
              id="birthDay"
              name="birthDay"
              disabled={disabled}
              validation={birthDayValidation}
              value={this.getDay()}
            />
          </Stack.Item>
          <Stack.Item className="Onboarding-YearInputContainer">
            <InputField
              id="birthYear"
              name="birthYear"
              disabled={disabled}
              validation={birthYearValidation}
              value={this.getYear()}
            />
          </Stack.Item>
        </Stack>
      </Fragment>
    );
  }
}

BirthdateWithInputFields.defaultProps = {
  disabled: false
};

BirthdateWithInputFields.propTypes = {
  birthdate: PropTypes.string.isRequired,
  disabled: PropTypes.bool
};

export default BirthdateWithInputFields;
